<div class="" id="allContent" >
<div class="nav-header-fixed" style="z-index: 11;">
    <header class="topbar"*ngIf="showNav && !isGiviScanApp"  [ngStyle]="!showMiMenu ? {'background-color': '#fff'} : {'background-color': '#1A1B27', 'color': '#fff'}">
        <nav class="d-flex-between align-items-center p-l-10 p-r-10">
            <div *ngIf="!showMiMenu">
                <i class="mdi mdi-menu" style="font-size: 30px;" (click)="onNavigateMenu()"></i>
            </div>
            <div *ngIf="showMiMenu">
                <i class="mdi mdi-close" style="font-size: 30px;" (click)="onClose()"></i>
            </div>
            <app-test-modal></app-test-modal>
            <div class="btn-givis" (click)="onNavigateGivis()">
                <div class="icon-wallet">
                    <img src="assets/images/iconomisgivis.png" width="25" height="30">
                </div>
                <div class="font-14 font-bold" style="margin-left: 35px;">Mis Givis</div>
            </div>
        </nav>
    </header>
    
    <!-- givi scan app header  -->
    <header class="d-flex-between align-items-center m-l-10 m-r-10" style="height: 50px;" *ngIf="showNav && isGiviScanApp" >
        <div  (click)="onNavigateGsaMenu()">
            <img class="round p-2" [src]="gsaLogo" width="24" *ngIf="gsaLogo">
            <img src="store-icon.png" width="24" *ngIf="!gsaLogo">
        </div>
        <div *ngIf="profile" (click)="onNavigateMenu()">
            <span class="d-flex-center-center">
                <span class="m-r-5" style="display: flex; align-items: center;">
                    <i class="mdi mdi-login text-primary" style="font-size: 24px;"></i>
                    <span class="font-16 font-bold text-dark pl-2">Volver a Givi</span>
                </span>
            </span>
        </div>
    </header>
</div>
